import React from "react";
import "./style.css";

function Styledh3(props) {
  return <h3 className="styledh3">{props.children}</h3>;
}

export default Styledh3;
